import { DataRequestState } from '@feathr/blackbox';

export const dataRequestStateColorMap: Record<DataRequestState, string> = {
  [DataRequestState.Draft]: 'default',
  [DataRequestState.Erroring]: 'red',
  [DataRequestState.Submitted]: 'cyan',
  [DataRequestState.InProgress]: 'yellow',
  [DataRequestState.NeedsFeedback]: 'orange',
  [DataRequestState.Live]: 'lime',
  [DataRequestState.Completed]: 'green',
  [DataRequestState.Canceled]: 'red',
  [DataRequestState.Archived]: 'violet',
};
